import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Package, Calendar, Users, MapPin, Home } from 'lucide-react';

const navItems = [
  { path: '/envios', label: 'Envios', icon: Package, accent: '#3B82F6' },
  { path: '/pickups', label: 'Recogida', icon: Calendar, accent: '#F59E0B' },
  { path: '/', label: 'Inicio', icon: Home, isCenter: true, accent: '#6366F1' },
  { path: '/remitentes', label: 'Remitente', icon: Users, accent: '#10B981' },
  { path: '/destinatarios', label: 'Destino', icon: MapPin, accent: '#EF4444' },
];

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <>
      {/* Spacer */}
      <div className="h-24" />

      <nav className="fixed bottom-0 left-0 right-0 z-50" data-testid="bottom-nav">
        {/* Glass background */}
        <div className="absolute inset-0 bg-white/80 backdrop-blur-xl border-t border-gray-200/50" />

        <div className="relative flex items-end justify-around max-w-lg mx-auto px-1 pb-1 pt-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;

            if (item.isCenter) {
              return (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className="flex flex-col items-center -mt-6 group relative"
                  data-testid="bottom-nav-inicio"
                >
                  {/* Glow ring */}
                  {isActive && (
                    <div className="absolute top-0 w-[68px] h-[68px] rounded-full opacity-30 animate-ping"
                      style={{ background: item.accent }} />
                  )}
                  <div
                    className="w-[60px] h-[60px] rounded-2xl flex items-center justify-center shadow-lg transition-all duration-300 rotate-0 group-hover:rotate-6 group-active:scale-90"
                    style={{
                      background: `linear-gradient(135deg, ${item.accent}, #002D62)`,
                      boxShadow: isActive
                        ? `0 8px 24px ${item.accent}50, 0 0 0 3px ${item.accent}30`
                        : `0 4px 12px rgba(0,0,0,0.15)`,
                      transform: isActive ? 'scale(1.1) translateY(-2px)' : undefined,
                    }}>
                    <Icon className="h-7 w-7 text-white" strokeWidth={2.5} />
                  </div>
                  <span className="text-[11px] font-extrabold mt-1 tracking-wide"
                    style={{ color: isActive ? item.accent : '#1F2937' }}>
                    {item.label}
                  </span>
                </button>
              );
            }

            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center py-2 px-1 min-w-[60px] group relative"
                data-testid={`bottom-nav-${item.label.toLowerCase()}`}
              >
                {/* Active indicator dot */}
                {isActive && (
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-6 h-1 rounded-full transition-all duration-300"
                    style={{ background: item.accent }} />
                )}

                <div
                  className="p-2.5 rounded-2xl transition-all duration-300 group-active:scale-90"
                  style={{
                    background: isActive ? `${item.accent}15` : 'transparent',
                    transform: isActive ? 'translateY(-2px)' : undefined,
                  }}>
                  <Icon
                    className="h-6 w-6 transition-all duration-300"
                    strokeWidth={isActive ? 2.5 : 1.8}
                    style={{ color: isActive ? item.accent : '#B0B7C3' }}
                  />
                </div>
                <span
                  className="text-[10px] font-extrabold mt-0.5 transition-colors duration-300 tracking-wide"
                  style={{ color: isActive ? item.accent : '#1F2937' }}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default BottomNav;
